export default [
  {
    path: "/hr-dashboard",
    name: "hr-main",
    component: () => import("../../modules/HR/HRDashboard.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["hr"],
    },
  },
];
